import TimerCountDown from 'presentation/components/TimerCountDown';
import { OTPComponent } from './OTP';

interface props {
    otp: string;
    onChange: (value: string) => void;
    reSendOtp: () => void;
    showTimer: boolean;
    setShowTimer: (value: boolean) => void;
    errMessage?: string;
}

export const InputOTP = ({
    otp,
    onChange,
    reSendOtp,
    showTimer,
    setShowTimer,
    errMessage,
}: props) => {
    return (
        <>
            <div
                className="title"
                style={{ width: '100%', textAlign: 'center', marginTop: 24, marginBottom: 24 }}
            >
                パスワードの再設定
            </div>
            <div className="otp-title" style={{ marginBottom: 16 }}>
                認証コードを入力してください。
            </div>
            <div className="otp-sub-title" style={{ marginBottom: 16 }}>
                メールアドレスに認証コードを送りました。
            </div>
            <div style={{ marginBottom: 16 }}>
                <OTPComponent value={otp} valueLength={6} onChange={onChange} />
                {errMessage && (
                    <div className="flex relative mt-[5px] h-[10px]">
                        <div
                            id="otp_help"
                            className="ant-form-item-explain ant-form-item-explain-connected"
                            role="alert"
                        >
                            <div className="ant-form-item-explain-error">{errMessage}</div>
                        </div>
                    </div>
                )}
            </div>
            <div className="otp-footer">
                認証コードが届きませんか？
                <div
                    className={`button-style link-resend ${showTimer ? 'disabled' : ''}`}
                    onClick={showTimer ? undefined : reSendOtp}
                >
                    再送信
                </div>
                {showTimer && (
                    <TimerCountDown
                        initialTime={2 * 60}
                        whenDone={() => {
                            setShowTimer(false);
                        }}
                    />
                )}
            </div>
        </>
    );
};
